<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">油卡充值场景介绍</p>
        <p>便捷、快速、优惠的线上油卡充值</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p
          v-for="(nl, index) in navList"
          :key="index"
          :class="anchorId == index ? 'nowAnchor' : ''"
          @click="changeanchorId(index, nl.id)"
        >
          {{ nl.text }}
        </p>
      </div>
    </div>
    <!-- 中心功能 -->
    <section class="first-introduce flexDiv mainDivWidth" id="centralFunction">
      <div class="introduceTextImg">
        <img
          src="static/img/sceneImg/scene02-Oilpay/centerFunImg.png"
          class="introduceImg"
        />
      </div>
      <div class="first-introduceText">
        <div class="introduceText-Title flexDiv">
          <p class="titleBg">中心功能</p>
          <p class="subheading">CENTRAL FUNCTION</p>
        </div>
        <div class="cer-FunCon">
          <p>
            通过搭建线上充值功能，提供便捷、快速、优惠的油卡充值方式，来满足用户的线上充值消费需求。
          </p>
          <p>
            维纳股份搭建加油卡在线充值平台实现用户在线充值，可以将模块以Html5技术形式输出给合作的第三方企业。
            同时引入并整合各类营销活动资源，给用户带去加油卡充值优惠补贴。
          </p>
        </div>
      </div>
    </section>
    <!-- 合作优势 -->
    <section class="advantagesCon" id="advantagesCon">
      <div class="mainDivWidth">
        <h3 class="sectionTitle textCenter whiteText">合作优势</h3>
        <div class="trisectionImgTextDiv flexDiv smallRadius">
          <div
            class="flexDiv"
            v-for="(sl, index) in advantagesList"
            :key="index"
          >
            <div class="imgDiv">
              <img :src="sl.img" />
            </div>
            <div class="textDiv">
              <p class="cooper-title textCenter" v-text="sl.title"></p>
              <p v-text="sl.text"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 充值流程 -->
    <section class="mainDivWidth" id="top-upProcess">
      <h3 class="sectionTitle">充值流程</h3>
      <div class="flexDiv privilegePay">
        <div v-for="(tpl, index) in topupProcess" :key="index">
          <img :src="tpl.img" />
          <p v-text="tpl.text"></p>
        </div>
      </div>
    </section>
    <!-- 合作方式 -->
    <section id="cooperation">
      <h3 class="sectionTitle">合作方式</h3>
      <div class="mainDivWidth smallRadius joinUpFlow h5-joinUpFlow">
        <p class="flowTitle flowTitle-bg01" id="joinUpFlow">
          直接充值到用户油卡
        </p>
        <div class="definite-flow flow-sevenStep flexDiv">
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-01.png"
                class="allImgW"
              />
            </div>
            <p>绑定新油卡或者选择已绑定油卡</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-02.png"
                class="allImgW"
              />
            </div>
            <p>选择充值金额</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-03.png"
                class="allImgW"
              />
            </div>
            <p>选择支付方式</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-04.png"
                class="allImgW"
              />
            </div>
            <p>选择可选优惠</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-05.png"
                class="allImgW"
              />
            </div>
            <p>在线支付</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-06.png"
                class="allImgW"
              />
            </div>
            <p>完成充值</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-07.png"
                class="allImgW"
              />
            </div>
            <p>用户在油站圈存之后方可使用</p>
          </div>
        </div>
      </div>
      <div class="mainDivWidth smallRadius joinUpFlow h5-joinUpFlow">
        <p class="flowTitle flowTitle-bg01">向用户发券码</p>
        <div class="definite-flow flow-sevenStep flexDiv">
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-08.png"
                class="allImgW"
              />
            </div>
            <p>发码线下充值</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-02.png"
                class="allImgW"
              />
            </div>
            <p>选择充值金额</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-03.png"
                class="allImgW"
              />
            </div>
            <p>选择支付方式</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-04.png"
                class="allImgW"
              />
            </div>
            <p>选择可选优惠</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-05.png"
                class="allImgW"
              />
            </div>
            <p>在线支付</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-09.png"
                class="allImgW"
              />
            </div>
            <p>支付完成后给用户发送数字码</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-07.png"
                class="allImgW"
              />
            </div>
            <p>用户持码在油站营业厅给油卡充值</p>
          </div>
        </div>
      </div>
      <div class="mainDivWidth smallRadius joinUpFlow h5-joinUpFlow">
        <p class="flowTitle flowTitle-bg01">券码采购</p>
        <div class="definite-flow flow-sevenStep flexDiv">
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-10.png"
                class="allImgW"
              />
            </div>
            <p>向我方采购券码</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-02.png"
                class="allImgW"
              />
            </div>
            <p>提供充值服务</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-11.png"
                class="allImgW"
              />
            </div>
            <p>用户购买券码</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-04.png"
                class="allImgW"
              />
            </div>
            <p>选择可选优惠</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-05.png"
                class="allImgW"
              />
            </div>
            <p>在线支付</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-09.png"
                class="allImgW"
              />
            </div>
            <p>支付完成后给用户发送数字码</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene02-Oilpay/flowIcon-07.png"
                class="allImgW"
              />
            </div>
            <p>用户持码在油站营业厅给油卡充值</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "sceneOilPay",
  data: function() {
    return {
      anchorId: 0,
      navList: [
        { text: "中心功能", id: "centralFunction" },
        { text: "合作优势", id: "advantagesCon" },
        { text: "充值流程", id: "top-upProcess" },
        { text: "合作方式", id: "cooperation" }
      ],
      advantagesList: [
        {
          img: "static/img/sceneImg/scene02-Oilpay/advIcon01.png",
          title: "丰富平台场景",
          text: "油卡充值业务直接对接，丰富平台自身场景"
        },
        {
          img: "static/img/sceneImg/scene02-Oilpay/advIcon02.png",
          title: "丰富的营销资源",
          text:
            "汇集以中国银联、中国建设银行、中国平安、中国联通等合作方为代表的50多家行业客户资源，为用户提供丰富营销资源"
        },
        {
          img: "static/img/sceneImg/scene02-Oilpay/advIcon03.png",
          title: "带动平台交易",
          text: "刚需场景接入平台，带来更多的交易流水和交易量"
        }
      ],
      topupProcess: [
        {
          img: "static/img/sceneImg/scene02-Oilpay/phoneFlow01.png",
          text: "充值下单"
        },
        {
          img: "static/img/sceneImg/scene02-Oilpay/phoneFlow02.png",
          text: "选择支付方式、享受优惠"
        },
        {
          img: "static/img/sceneImg/scene02-Oilpay/phoneFlow03.png",
          text: "支付成功"
        }
      ],
      idconts:"",
    };
  },
  created(){
    this.idconts = this.getQueryString('idcont');
  },
  mounted() {
    if(this.idconts){
      $(".mainCon").css('margin-top','0')
      $("#nava").css('display','none')
      $(".scene-Header").css('display','none')
      $(".servebanner").css('display','none')
      $(".footer").css('display','none')
    }
  },
  methods: {
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id) {
      this.anchorId = num;
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      return false; // 返回false可以避免在原链接后加上#
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return r[2]; return null;
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/sceneCss/sceneStyle";
@import "../../assets/css/sceneCss/sceneTwo";
</style>



// WEBPACK FOOTER //
// src/pages/scenePage/scene2-oilPay.vue